import axios from 'axios/dist/axios';


const defaultState = {

    sharedQuestionsData: [],
    selectedRelatedSymptomList: [],
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    sharedQuestionsData:     defaultState.sharedQuestionsData,

    selectedRelatedSymptomList:         defaultState.selectedRelatedSymptomList,
};


// ======================================================================
// Getters
// ======================================================================

const getters = {

    getSharedQuestionsData: state => state.sharedQuestionsData,
    getSelectedRelatedSymptomList: state => state.selectedRelatedSymptomList,
    getSharedQuestionList (state) {
        return (typeof state.sharedQuestionsData.questions !== 'undefined')
            ? state.sharedQuestionsData.questions
            : [];
    },

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadSharedQuestionsData ({ commit }) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/sharedQuestions');
            axiosRequest.then((response) => {
                commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    submitSymptomQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });
            axiosRequest.then((response) => {

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });



                // // ------- Refresh SHARED question list. -------
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                }

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    rectifySelectedSymptomList({commit, getters}) {

        let getMainSymptom = getters.getMainSymptom;
        let getRelatedSymptomList = getters.getRelatedSymptomList;
        let getSelectedRelatedSymptomList = getters.getSelectedRelatedSymptomList;

        getSelectedRelatedSymptomList.forEach((crtSelectedSymptom) => {
            let crtSelectedCode = crtSelectedSymptom.code;

            if (crtSelectedCode !== getMainSymptom.code) {
                let relatedSymptomCorrespondingToCrtSelectedCode = getRelatedSymptomList.filter((symptom) => {
                    return (symptom.code === crtSelectedCode && symptom.state === relatedSymptomStates.HAVE_SYMPTOM);
                });

                if (relatedSymptomCorrespondingToCrtSelectedCode.length === 0) {
                    commit("removeSelectedSymptomFromList", crtSelectedCode);
                }
            }
        });
    },

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setSharedQuestionsData (state, newVal) {
        state.sharedQuestionsData = newVal;
    },




    enableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = true;
    },
    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },
    setSelectedRelatedSymptomList (state, value) {
        state.selectedRelatedSymptomList = value;
    },

    setSymptomSpecificQuestions (state, data) {
        // @TODO Prevent DUPLICATE IDs.
        let symptomItemIndex = state.selectedRelatedSymptomList.findIndex((symptom) => {
            return symptom.code == data.symptomCode;
        });

        if (symptomItemIndex !== -1 && typeof state.selectedRelatedSymptomList[symptomItemIndex] !== "undefined") {
            state.selectedRelatedSymptomList[symptomItemIndex].questionsData = data.questionsData;
        }
    },

    // ----------------------------------------------------------

    resetStore (state) {

        state.sharedQuestionsData                = defaultState.sharedQuestionsData;
        state.selectedRelatedSymptomList         = defaultState.selectedRelatedSymptomList;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfSharedQuestionsStore.js